
import { useSelector } from 'react-redux';

const  useCheckAuthorization = (required_permissions=[]) => {
    const { permissions} = useSelector(state => state.common)
    
    return required_permissions.some(r=> permissions.includes(r))
}

export default useCheckAuthorization;